import { Component, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { MultiLineBulkSwapHeaders } from '../../../common/models/data.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SuccessComponent } from '../success/success.component';
import { UtilsService } from 'src/app/services/utils.service';
import { SIM_CHANGE_CONST, COMMON_CONSTANTS, MANAGE_LINE_CONST, ENTITLEMENT_ACTIVITYNAMES } from '../../../common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { environment } from 'src/environments/environment';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { AlertConfirmPopupComponent, AlertConfirmPopupService } from 'src/app/common/alert-confirm-popup';
import { SimChangeErrorComponent } from '../sim-change-error/sim-change-error.component';
@Component({
  selector: 'app-sim-change',
  templateUrl: './sim-change.component.html',
  styleUrls: ['./sim-change.component.scss']
})
export class SimChangeComponent implements OnInit {

  selectedLines: any = '';
  sim: any;
  msisdn: number;
  simChangeConfirm: any;
  activeLines: any;
  requestSimChange: any;
  simImage = SIM_CHANGE_CONST.SIM_CHANGE_IMAGE;
  eSimImage = SIM_CHANGE_CONST.ESIM_CHANGE_IMAGE;
  pSimImage = SIM_CHANGE_CONST.PSIM_CHANGE_IMAGE;
  requestMultiSimChange: any;
  submitChangeValue = false;
  isMultiLineType = false;
  reasons: any;
  submitNextValue = [];
  multiLineBulkSwapHeaders: MultiLineBulkSwapHeaders = new MultiLineBulkSwapHeaders();
  authoringContentData: any;
  failedFlag: boolean;
  lengthOne = COMMON_CONSTANTS.DIGITS.ONE;
  indexZero = COMMON_CONSTANTS.DIGITS.ZERO;
  lengthNineteen = COMMON_CONSTANTS.DIGITS.NINETEEN;
  lengthTwenty = COMMON_CONSTANTS.DIGITS.TWENTY;
  updateSimData = null;
  multiSimChange = [];
  nonActiveLines = [];
  isLineDetailsWindow: boolean;
  isEndUser = this.utilsSvc.IsEndUser();
  isApprovalRequired: any;
  approvalActivitiesList: any;
  isSubmitReadOnly: boolean;
  ngbModalOptions: NgbModalOptions;
  esimEnabled: boolean;
  eSimSelected: boolean;
  authType_okta: boolean;
  enableProfile: boolean = false;
  ref: any;
  showNavigationLink: boolean;
  basicRef: any;

  constructor(public manageLineService: ManageLineService, private modalService: NgbModal,private alertModal: AlertConfirmPopupService,
    public utilsSvc: UtilsService, public _cacheSvc: HttpCacheService, private _loaderSvc: LoaderService, private _helperUtilSvc: HelperUtilityService) {
      this.isLineDetailsWindow = false;
    }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().changeSim;
    this.esimEnabled = environment.ENABLE_ESIM;
    this.authType_okta = this._helperUtilSvc.getAuthType() !== COMMON_CONSTANTS.IAM_KEY;
    this.activeLines = [];
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      container: '#am-container-custom',
    };
    this.failedFlag = false;
    // check if all selected lines are active
    if (this.selectedLines.length > COMMON_CONSTANTS.DIGITS.ZERO) {
      for (const line of this.selectedLines) {
        if (line.statusCode !== SIM_CHANGE_CONST.ACTIVE && line.statusCode !== MANAGE_LINE_CONST.RESERVED) {
          this.nonActiveLines.push(line);
        } else {
          this.activeLines.push(line);
        }
      }
    }
    this.isMultiLineType = Boolean((this.activeLines.length) > (COMMON_CONSTANTS.DIGITS.ONE));
    if (this.isMultiLineType) {
      this.activeLines[0].expendFlagValue = true;
    }
    this.isSubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity( ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE);
    this.getSimChangeReasons();

  }

  getSimChangeReasons() {
    this._loaderSvc.start();
    this.manageLineService.simChangeReasons().subscribe(reasons => {
      this._loaderSvc.stop();
      if (!isNullOrUndefined(reasons)) {
        this.reasons = !isNullOrUndefined(reasons.simChangeReason) ? reasons.simChangeReason : [];
      }
    }, err => {
      this._loaderSvc.stop();
      this.simChangeError(err);
    });
  }

  removeNumber(line: any, nextLine: any) {
    if (!isNullOrUndefined(line)) {
      const index = !isNullOrUndefined(this.activeLines) ? this.activeLines.indexOf(line) : COMMON_CONSTANTS.DIGITS.ZERO;
      this.activeLines.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
      if (!isNullOrUndefined(nextLine)) {
        const indexMultiLine =
          !isNullOrUndefined(this.submitNextValue) ?
            this.submitNextValue.indexOf(nextLine) : COMMON_CONSTANTS.DIGITS.ZERO;
        this.submitNextValue.splice(indexMultiLine, COMMON_CONSTANTS.DIGITS.ONE);
      } else {
        this.submitNextValue.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
      }
      this.manageLineService.changeCurrentSelection(line);
      this.submitChangeValue = Boolean(this.submitNextValue.length === (this.activeLines.length) && (this.checkSubmitEnable(this.submitNextValue)));
    }
    if(this.activeLines.length == COMMON_CONSTANTS.DIGITS.ONE){
      this.isMultiLineType = false
    }
  }
  selectedSimType(event){
    this.enableProfile = false;
    if(event.esimSelected){
      this.eSimSelected = true;
    }else{
      this.eSimSelected = false;
    }
  }

  enableProfileOverride(event){
    if(event.checked){
      this.enableProfile = true;
    }else{
      this.enableProfile = false;
    }
  }

  addProfileOverrideParam(){
    if(this.authType_okta && this.esimEnabled){
      this.requestSimChange.overrideProfile = (this.eSimSelected && this.enableProfile);
     }
  }

  sendSwapTypeParamForEnduser(){
    if(this.isEndUser && this.esimEnabled){
      let toSimType:any;
      let fromSimType:any = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_LINE_DETAILS));
      if(this.utilsSvc.isNotNullOrUndefined(fromSimType.eid)){
        fromSimType = SIM_CHANGE_CONST.SWAPTYPE_ESIM;
      }else{
        fromSimType = SIM_CHANGE_CONST.SWAPTYPE_SIM;
      }
      if(this.utilsSvc.isNotNullOrUndefined(this.requestSimChange.eid)
      && this.requestSimChange.eid.length === SIM_CHANGE_CONST.E_SIM_NUM_LENGTH){
        toSimType = SIM_CHANGE_CONST.SWAPTYPE_ESIM;
      }else if(this.utilsSvc.isNotNullOrUndefined(this.requestSimChange.newSim)){
        toSimType = SIM_CHANGE_CONST.SWAPTYPE_SIM;
      }
      this.requestSimChange.swapType = fromSimType+SIM_CHANGE_CONST.SWAPTYPE_TO+toSimType;
   }
  }
  updateReqBodyForSingleLine(){
    if(this.esimEnabled && this.eSimSelected){
      delete this.requestSimChange['newSim']
    }else{
      delete this.requestSimChange['eid']
    }
  }
  updateReqBodyForMultiLine(){
    for(let request of this.requestSimChange.requests){
      if(request.newSim == ''){
        delete request['newSim']
      }else if(request.eid == ''){
        delete request['eid']
      }
    }
  }
  simChangeNumber() {
    if (this.activeLines.length === COMMON_CONSTANTS.DIGITS.ONE) {
      this.updateReqBodyForSingleLine();
       this._loaderSvc.start();
       this.addProfileOverrideParam();
       this.sendSwapTypeParamForEnduser();
      this.manageLineService.simChange(this.requestSimChange).subscribe((simNumberRes: any) => {
        this._loaderSvc.stop();
          if (!isNullOrUndefined(simNumberRes) && simNumberRes.status === SIM_CHANGE_CONST.SUCCESS) {
            this.openSuccessModal(simNumberRes);
          } else {
            this.failedFlag = true;
          }
      }, err => {
        this.submitSimChangeError(err);
      });
    } else {
      this.multiLineBulkSwapHeaders.targetServiceName = SIM_CHANGE_CONST.SIM_SWAP_TXT;
      this.multiLineBulkSwapHeaders.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
      this.multiLineBulkSwapHeaders.requests = this.submitNextValue;
      this.requestSimChange = this.multiLineBulkSwapHeaders;
      this.updateReqBodyForMultiLine();
      this._loaderSvc.start();
      this.manageLineService.bulkSimChangeProcessor(this.requestSimChange).subscribe((simNumberRes: any) => {
        this._loaderSvc.stop();
        if (!isNullOrUndefined(simNumberRes) && !isNullOrUndefined(simNumberRes.status)
          && simNumberRes.status === SIM_CHANGE_CONST.SUCCESS) {
          this.openSuccessModal(simNumberRes);
        }
      }, err => {
        this.submitSimChangeError(err);
      });
    }
  }

  submitSimChangeError(err){
    this._loaderSvc.stop();
    if(this.esimEnabled && this.eSimSelected){
      this.displaySpecificError(err);
    }else{
      this.displayGenericError(err);
    }
  }
  displayGenericError(err){
    if(!this.isMultiLineType){
      this.manageLineService.close();
    }
    this.simChangeError(err);
  }

  displaySpecificError(err){
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    if(this.utilsSvc.isNotNullOrUndefined(err.error.error[0].userMessage) && err.error.error[0].userMessage.indexOf(SIM_CHANGE_CONST.INVALID_EID_ERROR)!=COMMON_CONSTANTS.DIGITS.MINUS_ONE){
      this.alertModal.isModalOpen = false;
      this.ref = this.modalService.open(AlertConfirmPopupComponent, ngbModalOptions);
      this.ref.componentInstance.title = COMMON_CONSTANTS.ALERT_TYPES.TRANSACTION_FAILURE;
      this.ref.componentInstance.message = SIM_CHANGE_CONST.ENTER_VALID_EID;
      this.ref.componentInstance.btnOkText = COMMON_CONSTANTS.OK;
    }else if(this.utilsSvc.isNotNullOrUndefined(err.error.error[0].userMessage) && err.error.error[0].userMessage.indexOf(SIM_CHANGE_CONST.SIM_NOT_VALID)!= COMMON_CONSTANTS.DIGITS.MINUS_ONE){
      this.manageLineService.close();
      this.basicRef = this.modalService.open(SimChangeErrorComponent, ngbModalOptions);
      this.basicRef.componentInstance.title = COMMON_CONSTANTS.ALERT_TYPES.TRANSACTION_FAILURE;
      this.basicRef.componentInstance.message = SIM_CHANGE_CONST.SIM_IN_USE;
      this.basicRef.componentInstance.footerBtnTxt = COMMON_CONSTANTS.OK;
    }else{
      this.displayGenericError(err);
      return;
    }
  }

  openSuccessModal(simNumberRes: any) {
    this.approvalActivitiesList = JSON.parse(this._cacheSvc.getFromSessionStorage('approvalFlags'));
    if (!isNullOrUndefined(this.approvalActivitiesList)) {
      for(let approval of this.approvalActivitiesList) {
        if (approval?.FlagName === COMMON_CONSTANTS.IS_SIM_SWAP_APPROVAL) {
          this.isApprovalRequired = approval.FlagValue;
        }
      }
    }
    this.manageLineService.close();

    const successModalRef = this.modalService.open(SuccessComponent,this.ngbModalOptions);
    successModalRef.componentInstance.token =
      (!isNullOrUndefined(simNumberRes.token)) ? simNumberRes.token : simNumberRes.orderId;
    successModalRef.componentInstance.isLineDetailsWindow = this.isLineDetailsWindow;
    if (this.isEndUser && this.activeLines.length === COMMON_CONSTANTS.DIGITS.ONE && this.isApprovalRequired === COMMON_CONSTANTS.DIGITS.ONE) {
      successModalRef.componentInstance.isConfirmationPopup = true;
      successModalRef.componentInstance.isSimChange = true;
      successModalRef.componentInstance.newSimNumber = this.requestSimChange.newSim ? this.requestSimChange.newSim : this.requestSimChange.eid;
      successModalRef.componentInstance.header = this.authoringContentData.simChangeConfirmationApproval;
      successModalRef.componentInstance.processText = this.authoringContentData.simChangeProcessText;
      successModalRef.componentInstance.modalBodyContent = this.authoringContentData.confirmationModalBody;
    } else {
      successModalRef.componentInstance.header = this.authoringContentData.simChangeRequestComplete;
    }
  }

  visibleSubmitButton(event: any) {
    if (!isNullOrUndefined(event)) {
      this.submitChangeValue = true;
      this.requestSimChange = event;
      this.authoringContentData.simChangeConfirm =
        this.authoringContentData.simChangeConfirm.replace(SIM_CHANGE_CONST.OLD_SIM, event.oldSim);
      this.authoringContentData.simChangeConfirm =
        this.authoringContentData.simChangeConfirm.replace(SIM_CHANGE_CONST.MSISDN, event.msisdn);
    } else {
      this.submitChangeValue = false;
      this.requestSimChange = event;
    }
  }

  visibleNextButton(event: any) {
    if (event) {
      const nextIndex = this.activeLines.findIndex(item => item.msisdn === event.msisdn);
      if (nextIndex >= this.indexZero) {
        this.submitNextValue[nextIndex] = event;
      }
    }
    this.multiSimChange = this.submitNextValue;
    this.submitChangeValue = Boolean(this.submitNextValue.length === (this.activeLines.length) && (this.checkSubmitEnable(this.submitNextValue)));
  }

  checkSubmitEnable(submitEnableValue) {
    let returnSubmitValue = true;
    for (let element of submitEnableValue) {
      if((this.esimEnabled && (this.utilsSvc.isNotNullOrUndefined(element) && element.newSim == '' && element.eid == '') || (!this.utilsSvc.isNotNullOrUndefined(element) || (element.newSim?.length < SIM_CHANGE_CONST.P_SIM_NUM_LENGTH && element.newSim !== '') || (element.eid!=='' && element.eid?.length < SIM_CHANGE_CONST.E_SIM_NUM_LENGTH)))
      ||
      (!this.esimEnabled && (!this.utilsSvc.isNotNullOrUndefined(element) || (element.newSim.length < SIM_CHANGE_CONST.P_SIM_NUM_LENGTH)))){
        returnSubmitValue = false;
      }
    }
    return returnSubmitValue;
  }

  simChangeError(error): void {
    this.utilsSvc.errorHandling(error);
  }
  getSimChangeEvent(evt) {
    this.updateSimData = evt;
  }

  // when expansion panel is closed we are showing message
  expansionPanelClosed(line) {
    line.msgShowOnPanel = true;
    line.expendFlagValue = false;
  }
  // when expansaion panel is open we are hiding message
  expansionPanelOpened(line) {
    line.msgShowOnPanel = false;
    line.expendFlagValue = true;
  }

  nextStep(line) {
    const nextIndex = this.activeLines.findIndex(item => item.msisdn === line.msisdn);
    if(this.activeLines.length -1 > nextIndex) {
      this.activeLines[nextIndex + 1].expendFlagValue = true;
    }
    this.activeLines[nextIndex].expendFlagValue = false;
  }
}
